const assignedLessonsUrl = '/assigned-lessons';

export default assignedLessonsUrl;
